/**
 * Search API client — fetches Bible text search results.
 */

import type { SearchResponse } from '@skjv/common';
import { apiPath } from '@utils/api-base';

interface SearchOptions {
  text: string;
  isExact: boolean;
  testament?: number;
  bookNumber?: number;
  limit?: number;
  offset?: number;
}

/** Fetch paginated search results from the API. */
export async function fetchSearchResults(options: SearchOptions): Promise<SearchResponse> {
  const response = await fetch(apiPath('v1/search'), {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(options),
  });

  if (!response.ok) throw new Error(`Search API error: ${response.status}`);
  return (await response.json()) as SearchResponse;
}
